import React from 'react'
import { DeviceTypeEnum } from '../../data/enums'
import styles from './TargetTypeIcon.module.css'

type TargetType = 'lot' | 'station' | 'device'

interface TargetTypeIconProps {
    type: TargetType
    deviceType?: string
    operation?: 'edit' | 'execute'
    actionType?: 'force_update' | 'sms'
}

const deviceIconMap: Record<string, string> = {
    [DeviceTypeEnum.SCANNER]: 'video_camera_back',
    [DeviceTypeEnum.TERMINAL]: 'terminal',
    [DeviceTypeEnum.DISPLAY]: 'tv',
    [DeviceTypeEnum.ACCESS_CONTROL]: 'door_front',
    [DeviceTypeEnum.TRAFFIC_LIGHT]: 'traffic',
    [DeviceTypeEnum.OCCUPANCY_DISPLAY]: 'counter_1',
    [DeviceTypeEnum.MONEY_EXCHANGER]: 'payments',
    [DeviceTypeEnum.SWITCH_BOX]: 'electrical_services',
    [DeviceTypeEnum.BARRIER_CONTROLLER]: 'fence'
}

const getIcon = (
    type: TargetType,
    operation?: 'edit' | 'execute',
    actionType?: 'force_update' | 'sms',
    deviceType?: string
): string => {
    if (operation === 'execute') {
        if (actionType === 'sms') return 'sms'
        if (actionType === 'force_update') return 'system_update'
    }
    if (type === 'lot') return 'local_parking'
    if (type === 'station') return 'display_settings'
    return (deviceType && deviceIconMap[deviceType]) || 'developer_board'
}

export const TargetTypeIcon = ({ type, deviceType, operation, actionType }: TargetTypeIconProps) => {
    const colorClass = operation === 'execute' ? styles.execute : styles[type]
    return (
        <div className={`${styles.container} ${colorClass}`}>
            <i className="material-icons">{getIcon(type, operation, actionType, deviceType)}</i>
        </div>
    )
}
